/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoWrikeProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-wrike-prod" */ './utils').then(
			(m) => m.ForgeUnitoWrikeProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-prod/icon' },
);

const LazyForgeUnitoWrikeProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-wrike-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoWrikeProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-wrike-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoWrikeProdIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoWrikeProdIconComponent />
	</Suspense>
);

export const ForgeUnitoWrikeProdSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoWrikeProdSearchResultIconComponent />
	</Suspense>
);
